<div class="col-12 d-flex flex-column flex-md-row text-end ps-0 pe-0" *ngIf="company.is_premium else visibleTemplate">
  <div class="col-md-2 flex-grow-1 mb-3 mb-md-0">
    <app-company-logo [company]="company" [scale]="1.7" [showTitle]="true" [maxTitleLines]="3"></app-company-logo>
  </div>
  <div class="d-flex flex-md-column justify-content-start align-items-center bg-body-tertiary pe-2 ps-2">
    <p class="bg-body-tertiary mb-0">TEAM POWER <i class="bi bi-question-circle ps-1" [matTooltip]="methodology.team_power" #tt_team_power="matTooltip" (click)="tt_team_power.toggle()"></i></p>
    <p class="display-6 text-primary mb-0 blurred-strong flex-grow-1 text-end">{{6.001 | number : '1.3-3'}}</p>
  </div>
  <div class="d-flex flex-md-column justify-content-start align-items-center border-end pe-2 ps-2">
    <div class="title-feature">
      CEO <i class="bi bi-question-circle ps-1" [matTooltip]="methodology.ceo" #tt_ceo="matTooltip" (click)="tt_ceo.toggle()"></i>
    </div>
    <button class="btn btn-link p-0 director-name-button flex-grow-1 text-end" type="button" (click)="openDirectorProfile(company, company.director)" *ngIf="company.director else NoDirector">
      <span class="line-clamp-1">{{[company.director.firstname,company.director.lastname] | joinArray}}</span>
    </button>
    <ng-template #NoDirector>
      <span> - </span>
    </ng-template>
  </div>
  <div class="d-flex flex-md-column justify-content-start align-items-center border-end pe-2 ps-2">
    <div class="title-feature">Board Demo
      <i class="bi bi-question-circle ps-1" [matTooltip]="methodology.board_demo" #tt_board_demo="matTooltip" (click)="tt_board_demo.toggle()"></i>
    </div>
    <p class="fw-bold mb-0 blurred flex-grow-1 text-end">{{0.001 | percent}} Female</p>
  </div>
  <div class="d-flex flex-md-column justify-content-start align-items-center border-end pe-2 ps-2">
    <div class="title-feature">Board Pay
      <i class="bi bi-question-circle ps-1" [matTooltip]="methodology.board_pay" #tt_board_pay="matTooltip" (click)="tt_board_pay.toggle()"></i>
    </div>
    <p class="fw-bold mb-0 blurred flex-grow-1 text-end">{{1000.001 | currency : 'USD' : 'symbol' : '1.0-0'}}</p>
  </div>
  <div class="d-flex flex-md-column justify-content-start align-items-center border-end pe-2 ps-2">
    <div class="title-feature">Biggest Influencer
      <i class="bi bi-question-circle ps-1" [matTooltip]="methodology.biggest_influencer" #tt_biggest_influencer="matTooltip" (click)="tt_biggest_influencer.toggle()"></i>
    </div>
    <button class="btn btn-link p-0 director-name-button flex-grow-1 text-end" type="button" (click)="openDirectorProfile(company, company.influencer)">
      <span class="line-clamp-1">{{[company.influencer.firstname,company.influencer.lastname] | joinArray}}</span>
    </button>
  </div>
  <div class="d-flex flex-md-column justify-content-start align-items-center border-end pe-2 ps-2">
    <div class="title-feature">Board Type
      <i class="bi bi-question-circle ps-1" [matTooltip]="methodology.board_type" #tt_board_type="matTooltip" (click)="tt_board_type.toggle()"></i>
    </div>
    <p class="fw-bold mb-0 blurred flex-grow-1 text-end">0.001</p>
  </div>
  <div class="d-flex flex-md-column justify-content-start align-items-center border-end pe-2 ps-2">
    <div class="title-feature">Network Concentration
      <i class="bi bi-question-circle ps-1" [matTooltip]="methodology.network_concentration" #tt_network_concentration="matTooltip" (click)="tt_network_concentration.toggle()"></i>
    </div>
    <p class="fw-bold mb-0 blurred flex-grow-1 text-end">{{0.001 | percent}}</p>
  </div>
  <div class="d-flex flex-md-column justify-content-start align-items-center border-end pe-2 ps-2">
    <div class="title-feature">Board Strength
      <i class="bi bi-question-circle ps-1" [matTooltip]="methodology.board_strength" #tt_board_strength="matTooltip" (click)="tt_board_strength.toggle()"></i>
    </div>
    <p class="fw-bold mb-0 blurred flex-grow-1 text-end">0.001</p>
  </div>
  <div class="d-flex flex-md-column justify-content-start align-items-center pe-2 ps-2">
    <div class="title-feature">Board Weakness
      <i class="bi bi-question-circle ps-1" [matTooltip]="methodology.board_weakness" #tt_board_weakness="matTooltip" (click)="tt_board_weakness.toggle()"></i>
    </div>
    <p class="fw-bold mb-0 blurred flex-grow-1 text-end">0.001</p>
  </div>
</div>

<ng-template #visibleTemplate>
  <div class="col-12 d-flex flex-column flex-md-row ps-0 pe-0">
    <div class="col-md-2 flex-grow-1 mb-3 mb-md-0">
      <app-company-logo [company]="company" [scale]="1.7" [showTitle]="true" [maxTitleLines]="3"></app-company-logo>
    </div>
    <div class="d-flex flex-md-column justify-content-start align-items-center bg-body-tertiary pe-2 ps-2">
      <p class="bg-body-tertiary mb-0">TEAM POWER <i class="bi bi-question-circle ps-1" [matTooltip]="methodology.team_power" #tt_team_power_v="matTooltip" (click)="tt_team_power_v.toggle()"></i></p>
      <p class="display-6 text-primary mb-0 flex-grow-1 text-end">{{company.team_power | number : '1.3-3'}}</p>
    </div>
    <div class="d-flex flex-md-column justify-content-start align-items-center border-end pe-2 ps-2">
      <div class="title-feature">
        CEO <i class="bi bi-question-circle ps-1" [matTooltip]="methodology.ceo" #tt_ceo_v="matTooltip" (click)="tt_ceo_v.toggle()"></i>
      </div>
      <button class="btn btn-link p-0 director-name-button flex-grow-1 text-end" type="button" (click)="openDirectorProfile(company, company.director)" *ngIf="company.director else NoDirector">
        <span class="line-clamp-1">{{[company.director.firstname,company.director.lastname] | joinArray}}</span>
      </button>
      <ng-template #NoDirector>
        <span> - </span>
      </ng-template>
    </div>
    <div class="d-flex flex-md-column justify-content-start align-items-center border-end pe-2 ps-2">
      <div class="title-feature">Board Demo
        <i class="bi bi-question-circle ps-1" [matTooltip]="methodology.board_demo" #tt_board_demo_v="matTooltip" (click)="tt_board_demo_v.toggle()"></i>
      </div>
      <p class="fw-bold mb-0 flex-grow-1 text-end">{{company.board_demo / 100| percent}} Female</p>
    </div>
    <div class="d-flex flex-md-column justify-content-start align-items-center border-end pe-2 ps-2">
      <div class="title-feature">Board Pay
        <i class="bi bi-question-circle ps-1" [matTooltip]="methodology.board_pay" #tt_board_pay_v="matTooltip" (click)="tt_board_pay_v.toggle()"></i>
      </div>
      <p class="fw-bold mb-0 flex-grow-1 text-end">{{company.board_pay | currency : 'USD' : 'symbol' : '1.0-0'}}</p>
    </div>
    <div class="d-flex flex-md-column justify-content-start align-items-center border-end pe-2 ps-2">
      <div class="title-feature">Biggest Influencer
        <i class="bi bi-question-circle ps-1" [matTooltip]="methodology.biggest_influencer" #tt_biggest_influencer_v="matTooltip" (click)="tt_biggest_influencer_v.toggle()"></i>
      </div>
      <button class="btn btn-link p-0 director-name-button flex-grow-1 text-end" type="button" (click)="openDirectorProfile(company, company.influencer)">
        <span class="line-clamp-1">{{[company.influencer.firstname,company.influencer.lastname] | joinArray}}</span>
      </button>
    </div>
    <div class="d-flex flex-md-column justify-content-start align-items-center border-end pe-2 ps-2">
      <div class="title-feature">Board Type
        <i class="bi bi-question-circle ps-1" [matTooltip]="methodology.board_type" #tt_board_type_v="matTooltip" (click)="tt_board_type_v.toggle()"></i>
      </div>
      <p class="fw-bold mb-0 flex-grow-1 text-end">{{company.board_type}}</p>
    </div>
    <div class="d-flex flex-md-column justify-content-start align-items-center border-end pe-2 ps-2">
      <div class="title-feature">Network Concentration
        <i class="bi bi-question-circle ps-1" [matTooltip]="methodology.network_concentration" #tt_network_concentration_v="matTooltip" (click)="tt_network_concentration_v.toggle()"></i>
      </div>
      <p class="fw-bold mb-0 flex-grow-1 text-end">{{company.network_concentration / 100 | percent}}</p>
    </div>
    <div class="d-flex flex-md-column justify-content-start align-items-center border-end pe-2 ps-2">
      <div class="title-feature">Board Strength
        <i class="bi bi-question-circle ps-1" [matTooltip]="methodology.board_strength" #tt_board_strength_v="matTooltip" (click)="tt_board_strength_v.toggle()"></i>
      </div>
      <p class="fw-bold mb-0 flex-grow-1 text-end">{{company.board_strength}}</p>
    </div>
    <div class="d-flex flex-md-column justify-content-start align-items-center pe-2 ps-2">
      <div class="title-feature">Board Weakness
        <i class="bi bi-question-circle ps-1" [matTooltip]="methodology.board_weakness" #tt_board_weakness_v="matTooltip" (click)="tt_board_weakness_v.toggle()"></i>
      </div>
      <p class="fw-bold mb-0 flex-grow-1 text-end">{{company.board_weakness}}</p>
    </div>
  </div>

</ng-template>
